module.exports = __webpack_public_path__ + "img/RETURN_SALE.05eb9f45.svg";